'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Styles = require("../styles");
var Header_1 = require("./Header");
var Minefield_1 = require("./Minefield");
var Notification_1 = require("./Notification");
var Game = /** @class */ (function (_super) {
    __extends(Game, _super);
    function Game(props) {
        var _this = _super.call(this, props) || this;
        _this.numValidTilesRevealed = 0;
        _this.state = {
            minesLeft: _this.props.gameConfig.numMines,
            livesLeft: _this.props.gameConfig.numLives,
            gameEnded: false,
        };
        _this.handleValidTilesRevealed = _this.handleValidTilesRevealed.bind(_this);
        _this.handleFlagsChanged = _this.handleFlagsChanged.bind(_this);
        _this.handleExplosion = _this.handleExplosion.bind(_this);
        return _this;
    }
    /**
     * Handles checking if the game has ended by having all valid tiles revealed.
     */
    Game.prototype.handleValidTilesRevealed = function (numTiles) {
        this.numValidTilesRevealed += numTiles;
        if (this.numValidTilesRevealed === this.props.gameConfig.dimensions.rows *
            this.props.gameConfig.dimensions.cols - this.props.gameConfig.numMines) {
            this.setState({ gameEnded: true });
        }
    };
    /**
     * Handles updating the number of non flagged mines.
     */
    Game.prototype.handleFlagsChanged = function (deltaFlags) {
        this.setState(function (prevState) {
            return ({ minesLeft: prevState.minesLeft - deltaFlags });
        });
    };
    /**
     * Handles a tile with a mine being revealed.
     */
    Game.prototype.handleExplosion = function () {
        var livesLeft = this.state.livesLeft - 1;
        if (livesLeft === 0) {
            this.setState({
                livesLeft: livesLeft,
                gameEnded: true,
            });
            return;
        }
        this.setState({ livesLeft: livesLeft });
    };
    /**
     * Returns any notifications to be displayed.
     */
    Game.prototype.getNotification = function () {
        if (this.state.livesLeft > 0) {
            return ('Congratulations!');
        }
        else {
            return ('Game Over!');
        }
    };
    Game.prototype.render = function () {
        return (React.createElement("div", { id: 'game', style: Styles.game },
            this.state.gameEnded ?
                React.createElement(Notification_1.Notification, { id: 'game-notifs', notifText: this.getNotification() }) :
                '',
            React.createElement(Header_1.Header, { minesLeft: this.state.minesLeft, lives: this.state.livesLeft, gameEnded: this.state.gameEnded }),
            React.createElement(Minefield_1.Minefield, { viewport: this.props.viewport, gameSeed: this.props.gameConfig.gameSeed, dimensions: this.props.gameConfig.dimensions, numMines: this.props.gameConfig.numMines, flagsEnabled: this.props.gameConfig.flagsEnabled, gameEnded: this.state.gameEnded, onValidTilesRevealed: this.handleValidTilesRevealed, onFlagsChanged: this.handleFlagsChanged, onExplosion: this.handleExplosion })));
    };
    return Game;
}(React.Component));
exports.Game = Game;
//# sourceMappingURL=Game.js.map


//////////////////
// WEBPACK FOOTER
// ./src/js/components/Game.js
// module id = 34
// module chunks = 0